module.exports = require("@material-ui/icons/ArrowDropUp");